export default function SwiperNavigation({
  activeIdx,
  length,
}: {
  activeIdx: number;
  length: number;
}) {
  return (
    <div className="flex gap-1 mt-5 items-end">
      <span className="text-3xl">{activeIdx}</span> / {length}
      {/* {Array.from({ length }).map((_, idx) => (
        <div
          className={cn(
            idx + 1 === activeIdx ? "bg-zinc-600 w-5" : "bg-zinc-800 w-2",
            " rounded-full h-2  transition-all"
          )}
        />
      ))} */}
    </div>
  );
}
